import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-locked',
  templateUrl: './locked.component.html',
  styleUrls: ['./locked.component.scss']
})
export class LockedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
